import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Typeahead from './Typeahead';

const QuestionContainer = styled.div`
  position: relative;
`;

class Question extends React.Component {
  constructor(props) {
    super(props);
    this.state = { value: '' };
  }
  onChange(value, acceptPartial) {
    const question = this.checkValid(value, acceptPartial);
    if (question) {
      this.setState({ value: question.title });
      this.props.storeQuestionCode(question.questionCode);
    } else if (this.props.storedQuestionCode !== '') {
      this.props.storeQuestionCode('');
    }
  }
  checkValid(value, acceptPartial) {
    if (value.length > 0) {
      let question = this.props.suggestions.filter((s) =>
        s.questionCode === value || s.title === value
      );

      const lowerValue = value.toLowerCase();

      if (question.length === 0 && acceptPartial) {
        question = this.props.suggestions.filter((s) =>
          s.questionCode.toLowerCase().indexOf(lowerValue) >= 0 || s.title.toLowerCase().indexOf(lowerValue) >= 0
        );
      }

      if (question.length === 1) {
        return question[0];
      }
    }
    return false;
  }
  render() {
    const { suggestions, ...other } = this.props;
    return (
      <QuestionContainer>
        <h4>Question</h4>
        <Typeahead
          onChange={(v, a) => { this.onChange(v, a); }}
          suggestions={suggestions.map((v) => ({ value: v.questionCode, text: v.title }))}
          value={this.state.value}
          {...other}
        />
      </QuestionContainer>
    );
  }
}

Question.propTypes = {
  suggestions: PropTypes.array,
  storeQuestionCode: PropTypes.func,
  storedQuestionCode: PropTypes.string,
  createQuestionControl: PropTypes.func,
};

export default Question;



// WEBPACK FOOTER //
// ./app/components/FormControls/Question/index.js